import { pdfjs } from 'react-pdf';

const pdfAssetBase = `${import.meta.env.BASE_URL}pdfjs/`;

pdfjs.GlobalWorkerOptions.workerSrc = `${pdfAssetBase}pdf.worker.min.mjs`;

/** Required for many real-world PDFs (embedded fonts, CJK, ICC). Self-hosted under /pdfjs/. */
export const PDF_DOCUMENT_OPTIONS = {
  isEvalSupported: false,
  withCredentials: true,
  cMapUrl: `${pdfAssetBase}cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: `${pdfAssetBase}standard_fonts/`,
  wasmUrl: `${pdfAssetBase}wasm/`
} as const;
